import React, {
	useState, useEffect
}from "react"
import {
	Modal, Form, Input
}from "antd"
const { TextArea } = Input
import {
	useSelector, useDispatch
}from "react-redux"
import i18nGlobal from "../../../localization"
import i18n from "./localization"
import i18n2 from "../localization"
import UploadFile from "../../UploadFile"
import CustomButton from "../../../components/ButtonCustom"
import {
	appealsActions
}from "../store/actions"
import Notifications from "../../../helpers/Notifications"
import { useMemo } from "react"
import sign from "../../../helpers/sign"
import notice from "../../../components/Notice"
import {
	default as uploadFileLocale
} from '../../UploadFile/localization'
import './style.css'

const RecallByRegistratorModal = ({ isRu, reOrgAppealId, underControl = false }) => {
	const [form] = Form.useForm()
	const [visible, setVisible] = useState(false)
	const [fileList, setFileList] = useState([])
	const [reportFileList, setReportFileList] = useState([])
	const [reportFileSignatureList, setReportFileSignatureList] = useState([])
	const { recallByRegistratorResult, recallByRegistratorLoading, reOrgAppeal} = useSelector((state) => state.appealsReducer)
	const { systemEnvironment } = useSelector((state) => state.userReducer)
	const {messages} = useSelector((state) => state.appealsControlReducer);
	const dispatch = useDispatch()
	const maxNumberOfFiles = 5

	useEffect(() => {
		return () => {
			dispatch(appealsActions.clearRecallByRegistrator())
		}
	}, [])

	useEffect(() => {
		if (recallByRegistratorResult){
			Notifications.successNotice(
				reOrgAppeal?.controlReOrgs?.length || underControl == true 
				? (messages?.length>0 
				   ? i18n2.reportForControlOrgSuccessCreate[isRu] 
				   : i18n2.appealGetStatusOnControl[isRu])
				: i18n.recallByRegistratorSuccess[isRu]
				)
			handleCancel()
		}
	}, [recallByRegistratorResult])

	function handleCancel(){
		setVisible(false)
		setFileList([])
		setReportFileList([])
		setReportFileSignatureList([])
		dispatch(appealsActions.clearRecallByRegistrator())
	}

	const recallByRegistrator = (fd) =>{
		const filesToUpload = getUnloadedFilesFromList()
		if(form.getFieldValue("reportText")?.trim())
			fd.append('ReportText', form.getFieldValue("reportText").trim())
		filesToUpload?.forEach(file => {
			fd.append('reportFiles', file.originFileObj)
		})
		reportFileSignatureList?.forEach(sign => {
			fd.append('ReportFileSignatures', sign)
		})

		dispatch(appealsActions.recallByRegistrator(fd))
	}

	const submitValues = async () => {
		const fd = new FormData()
		fd.append("ReOrgAppealId", reOrgAppealId)
		fileList?.forEach((file) => {
			fd.append("Files", file.originFileObj)
		})
		if (systemEnvironment.ecpEnabled && form.getFieldValue("reportText")?.trim()) {
			await sign(window.btoa(unescape(encodeURIComponent(form.getFieldValue("reportText")))), false, systemEnvironment.cp_address_n).then(result => {
				if (result.res) {
					fd.append("reportSignature", result.res.data.cms)
					recallByRegistrator(fd)
				}
			})
		} else {
			recallByRegistrator(fd)
		}
	}

	const reader = useMemo(() => {
		const fileReader = new FileReader()
		fileReader.onerror = error => Notifications.errorNotice(error)

		return fileReader
	}, [])

	reader.onload = (evt) => {
		const base64 = evt.target.result.toString().replace(/^data:(.*,)?/, '')
		sign(base64, true, systemEnvironment.cp_address_n).then(result => {
			if (result.res) {
				setReportFileSignatureList([...reportFileSignatureList, result.res.data.cms])
			}
			else if (result.error)
				setReportFileSignatureList([])
		})
	}

	const getUnloadedFilesFromList = () => reportFileList?.filter(file => !file.id)

	useEffect(() => {
		const filesToUpload = getUnloadedFilesFromList()
		if (filesToUpload.length && reportFileSignatureList.length > 0 && reportFileSignatureList.length == filesToUpload?.length) {
			submitValues()
		} else if (filesToUpload.length && reportFileSignatureList.length > 0 && reportFileSignatureList.length < filesToUpload?.length) {
			reader.readAsDataURL(filesToUpload[reportFileSignatureList.length].originFileObj)
		}
	}, [reportFileSignatureList])

	const onFinish = () => {
		try {
			const filesToUpload = getUnloadedFilesFromList()
			if (!systemEnvironment.ecpEnabled) {
				submitValues()
			}
			else {
				if (filesToUpload.length)
					reader.readAsDataURL(filesToUpload[0].originFileObj)
				else
					submitValues()
			}
		} catch (e) {
			notice('error', 'Не удалось отозвать обращение заявителем.', e.message, 5)
		}
	}

	const handleChangeReportFile = (val) => {
		if (val.fileList.length <= maxNumberOfFiles) {
			setReportFileList(val.fileList)
			setReportFileSignatureList([])
		}
		else
			Notifications.errorNotice(uploadFileLocale.maxCountFiles[isRu])
	}

	const handleRemoveReportFiles = (id) => {
		const newList = reportFileList.filter((item) => item.uid != id.FileId && item.id != id.FileId)
		setReportFileList(newList)
		setReportFileSignatureList([])
	}

	const handleChangeReasonFile = (val) => {
		if (val.fileList.length <= maxNumberOfFiles) {
			setFileList(val.fileList)
		}
		else
			Notifications.errorNotice(uploadFileLocale.maxCountFiles[isRu])
	}

	const handleRemoveReasonFiles = (id) => {
		const newList = fileList.filter((item) => item.uid != id.FileId && item.id != id.FileId)
		setFileList(newList)
	}


	return (
		<>
			<CustomButton
				loading={ recallByRegistratorLoading }
				type="orange"
				onClick={ () => setVisible(true) }
			>
				{ i18n.recallByRegistrator[isRu] }
			</CustomButton>
			<Modal
				destroyOnClose
				footer={ null }
				title={ i18n.recallByRegistrator[isRu] }
				visible={ visible }
				onCancel={ handleCancel }
			>
				<Form 
					form = {form}
					name="recallByRegistrator"
					onFinish={onFinish}
				>
					<div>{i18n.basis[isRu]}</div>
					<Form.Item name="files">
						<UploadFile
							fileList={ fileList }
							removeFiles={ handleRemoveReasonFiles }
							onChangeCustom={ handleChangeReasonFile }
						/>
					</Form.Item>
					{reOrgAppeal?.controlReOrgs?.length || underControl == true ? <>
						<div className="form__divider"></div>
						<Form.Item
							name="reportText"
							label = {i18n2.reportForOrganization[isRu]}
							labelCol={{span: 24}}
							rules={[
								{
									required: true,
									whitespace: true,
									message: i18n2.reportTextForOrganizationMessage[isRu]
								}
							]}
						>
							<TextArea
								autoSize={{
									minRows: 3,
									maxRows: 8
								}}
								maxLength={5000}
							/>
						</Form.Item>
						<Form.Item
							name="filesForOrganization"
							label={<div className="label-reason-form-upload">
								{i18n2.filesForOrganization[isRu]}
							</div>
							}
						>
							<UploadFile
								fileList={reportFileList}
								listType="text"
								onChangeCustom={handleChangeReportFile}
								removeFiles={handleRemoveReportFiles}
							/>
						</Form.Item>
					</>
						: null}


					<Form.Item>
						<CustomButton
							loading={ recallByRegistratorLoading }
							type="orange"
							htmlType = "submit"
						>
							{ i18nGlobal.submit[isRu] }
						</CustomButton>
					</Form.Item>
				</Form>
			</Modal>
		</>
	)
}

export default RecallByRegistratorModal
